import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TaxDocSummary } from 'src/app/models/tax-doc-summary';
import { TaxDocClient } from 'src/app/TaxDocNotifier-api';
import { inOutAnimation } from "../../../shared/animations/in-out.animation";
import { IndexSummaryTableService } from './index-summary-table.service';
import { tap } from 'rxjs';

@Component({
  selector: 'index-summary-table',
  templateUrl: './index-summary-table.component.html',
  styleUrl: './index-summary-table.component.scss',
  animations: [inOutAnimation],
  encapsulation: ViewEncapsulation.None
})
export class IndexSummaryTable implements OnInit {
  rows: TaxDocSummary[] = null;
  displayData: TaxDocSummary[] = null;

  loading: boolean = true;
  error: boolean = false;

  constructor(
    public tableService: IndexSummaryTableService,
    private taxDocClientService: TaxDocClient    
  ) { }

  ngOnInit(): void {
    this.getTaxDocSummaries();
    this.tableService
      .displayTableData$
      .pipe(tap(res => this.displayData = res))
      .subscribe();    
  }

  getTaxDocSummaries(): void {
    this.taxDocClientService.getTaxDocSummaries()
      .subscribe({
        next: res => {
          this.rows = res;
          this.loading = false;
          this.tableService.setSourceTableDataObs(this.rows);
        },
        error: () => {
          this.error = true;
          this.loading = false;
        }
      });
  }
}
